import Splide from '@splidejs/splide';
import { getInStockRecommendations } from '../services/recommendation.service';
import '../../styles/web-components/recommendations-carousel.scss';
import { DESKTOP_WIDTH } from '../vue/constants/devices';
const defaultCarouselOptions = {
    mediaQuery: "min",
    gap: "12px",
    perPage: 2,
    arrows: true,
    pagination: false,
    padding: { right: "15%" },
    breakpoints: {
        [DESKTOP_WIDTH]: {
            destroy: true
        }
    }
};
const template = `
  <h2 class="recommendations-carousel__title">${window.UNTUCKitConfig.inStockRecommendationTitle}</h2>
  <section class="splide recommendations-carousel__slider" aria-label="In-Stock Recommendations">
    <loading-spinner></loading-spinner>
    <div class="splide__track">
      <ul class="splide__list"></ul>
    </div>
  </section>
`;
class RecommendationsCarousel extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        this.innerHTML = template;
        const size = this.getAttribute('size');
        const fit = this.getAttribute('fit');
        const gender = this.getAttribute('gender');
        const sku = this.getAttribute('sku');
        const carouselOptions = defaultCarouselOptions;
        getInStockRecommendations({ size, fit, gender, sku }, { maxProducts: 6 }).then((recs) => {
            var _a;
            if ((_a = recs === null || recs === void 0 ? void 0 : recs.slots) === null || _a === void 0 ? void 0 : _a.length) {
                const currencySymbol = window.UNTUCKitConfig.cartCurrencySymbol;
                const slideHtmlString = recs.slots.map((s) => s.item).reduce((acc, rec) => {
                    const recUrl = new URL(rec.url);
                    recUrl.searchParams.append("sku", rec.sku);
                    const salePrice = `${currencySymbol}${rec.sale}`;
                    const regularPrice = `${currencySymbol}${rec.original_price}`;
                    const htmlString = `
            <li class="splide__slide recommendations-carousel__slide">
              <a href="${recUrl}">
                <img class="recommendations-carousel__image" width="140" height="167" alt="${rec.name}" src="${rec.image_url}"/>
                <div class="recommendations-carousel__info">
                  <p class="recommendations-carousel__name">${rec.name}</p>
                  <p class="recommendations-carousel__price" data-product-id="${rec.group_id}">
                    <span class="recommendations-carousel__regular-price ${rec.sale ? 'recommendations-carousel__regular-price--sale' : ''}" aria-label="regular price ${regularPrice}">${regularPrice}</span>
                    <span class="recommendations-carousel__sale-price ${rec.sale ? '' : 'ADA__visually-hidden'}" aria-label="sale price ${salePrice}">${salePrice}</span>
                  </p>
                </div>
              </a>
            </li>
          `;
                    return acc += htmlString;
                }, '');
                this.querySelector('.splide__list').innerHTML = slideHtmlString;
                this.carousel = new Splide(this.querySelector('.splide'), carouselOptions).mount();
            }
            else {
                this.displayError();
            }
        }).catch(() => this.displayError()).finally(() => this.hideLoader());
    }
    disconnectedCallback() {
        if (this.carousel) {
            this.carousel.destroy();
        }
    }
    displayError(msg = "Sorry, we're unable to provide recommendations at the moment.") {
        const container = this.querySelector(".recommendations-carousel__slider");
        if (container) {
            container.innerHTML = `<p class="recommendations-carousel__error-message">${msg}</p>`;
            container.style.visibility = "visible";
        }
    }
    hideLoader() {
        const spinner = this.querySelector('loading-spinner');
        if (spinner) {
            spinner.setAttribute("show", "false");
        }
    }
}
if (!window.customElements.get("recommendations-carousel")) {
    customElements.define("recommendations-carousel", RecommendationsCarousel);
}
